import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { FINANCE_APPROVAL_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export function useAddToLot(
  briefId: string,
  handleError?: (
    infs: {
      status: string;
      reason: string;
      briefInfluencer: IBriefInfluencerV2;
      reasonType: string;
    }[]
  ) => void
) {
  const {
    mutate: addToLot,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation({
    mutationFn: ({
      ids,
      remarks,
      purchaseProof,
    }: {
      ids: string[];
      remarks: string;
      purchaseProof: string;
    }) =>
      FinanceApprovalService.addToFinanceLots(
        ids,
        briefId,
        remarks,
        purchaseProof
      ).catch(async (err) => {
        const responseBody = await err.response.json();

        if (responseBody?.error?.recurrsiveError?.data) {
          const errorInfluencers =
            responseBody?.error?.recurrsiveError?.data?.filter(
              (item: any) => item.status === "failed"
            ) || [];

          if (errorInfluencers.length > 0) {
            handleError?.(errorInfluencers);
            throw err;
          }
        }
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: false },

    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...BRIEF_LOT_FACETS_QUERY_KEY(briefId)],
        });
        c.invalidateQueries({
          queryKey: [...FINANCE_APPROVAL_QUERY_KEY],
        });
        c.invalidateQueries({
          queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
        });
      }, 1000);
    },
  });

  return {
    addToLot,
    isAdding,
    isAdded,
  };
}
